// src/pages/ContactPage.jsx
import React, { useState } from "react";
import AuthNav from "../components/AuthNav";
import "../styles/Auth.css";

function ContactPage() {
  const [name, setName] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [contactEmail, setContactEmail] = useState("");

  const handleSubmit = async function (e) {
    e.preventDefault();

    if (!name || !subject || !message || !contactEmail) {
      window.alert("请完整填写所有信息");
      return;
    }

    try {
      const res = await fetch(
        "https://us-central1-riceroma202606.cloudfunctions.net/contactForm",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name: name,
            subject: subject,
            message: message,
            contact: contactEmail,
          }),
        }
      );

      let data = null;
      try {
        data = await res.json();
      } catch (err) {
        data = null;
      }

      // ✅ 后端返回 { success: true }，这里改成判断 data.success
      if (res.ok && data && data.success) {
        window.alert("已收到您的留言，谢谢！");
        setName("");
        setSubject("");
        setMessage("");
        setContactEmail("");
      } else {
        window.alert("提交失败，请稍后再试。");
      }
    } catch (err) {
      console.error("contact submit error:", err);
      window.alert("网络异常，请稍后再试。");
    }
  };

  return (
    <div className="dashboard-background">
      <AuthNav active="contact" />

      <div className="auth-page-container contact-page">
        <div className="contact-main">
          <div className="card contact-map-card">
            <iframe
              title="Riceroma location"
              className="contact-map-iframe"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2885.244635502832!2d-79.414!3d43.7695!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2s5418%20Yonge%20St%20Unit%2012%2C%20North%20York!5e0!3m2!1sen!2sca!4v0000000000"
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          <div className="card contact-info-card">
            <p className="contact-line">
              <span className="contact-label-strong">Address 地址：</span>
              5418 Yonge Street, Unit 12, North York, Ontario
            </p>
            <p className="contact-line">
              <span className="contact-label-strong">Email 邮箱：</span>
              <a
                href="mailto:support@riceroma.ca"
                className="contact-email-link"
              >
                support@riceroma.ca
              </a>
            </p>
          </div>

          <div className="card contact-form-card">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="contact-field">
                <label className="contact-field-label">
                  Your Name 您的称呼 *
                </label>
                <input
                  type="text"
                  className="contact-input"
                  placeholder="Example：John 例如：老张 "
                  value={name}
                  onChange={function (e) {
                    setName(e.target.value);
                  }}
                />
              </div>

              <div className="contact-field">
                <label className="contact-field-label">
                  Subject 主题 *
                </label>
                <input
                  type="text"
                  className="contact-input"
                  placeholder="Example：Issues about Membership 例如：会员问题、预订咨询等"
                  value={subject}
                  onChange={function (e) {
                    setSubject(e.target.value);
                  }}
                />
              </div>

              <div className="contact-field">
                <label className="contact-field-label">
                  Message 内容 *
                </label>
                <textarea
                  className="contact-textarea"
                  placeholder="Please leave your message here 请写下您的问题或建议"
                  value={message}
                  onChange={function (e) {
                    setMessage(e.target.value);
                  }}
                />
              </div>

              <div className="contact-field">
                <label className="contact-field-label">
                  Your Email 您的邮箱 *
                </label>
                <input
                  type="email"
                  className="contact-input"
                  placeholder="something@example.com"
                  value={contactEmail}
                  onChange={function (e) {
                    setContactEmail(e.target.value);
                  }}
                />
              </div>

              <button type="submit" className="button contact-submit">
                Submit 提交
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;
